import { render, staticRenderFns } from "./mianImg.vue?vue&type=template&id=65f5da73&scoped=true&"
import script from "./mianImg.vue?vue&type=script&lang=js&"
export * from "./mianImg.vue?vue&type=script&lang=js&"
import style0 from "./mianImg.vue?vue&type=style&index=0&id=65f5da73&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f5da73",
  null
  
)

export default component.exports